<template>
  <q-page class="content">
    <p>EVENTS</p>
    <p>{{ $t("global.hello") }}</p>
    <q-btn
      icon="cached"
      color="primary"
      label="Change Local"
      @click="changeLocal()"      
    />
    <p>{{$i18n.locale}}</p>
    <q-btn
      icon="cached"
      color="primary"
      label="Load Dialog 1"
      @click="loadDialog('SideDialog1')"      
    />
    <q-btn
      icon="cached"
      color="primary"
      label="Load Dialog 2"
      @click="loadDialog('SideDialog2')"      
    />
    <q-btn
      icon="cached"
      color="primary"
      label="Close Side Dialog"
      @click="closeDialog()"      
    />

    <q-select
    stack-label="I18n"
    :options="[
      { label: 'English (US)',         value: 'en-us' },
      { label: 'English (UK)',         value: 'en-uk' },
      { label: 'Romanian',             value: 'ro' },
      { label: 'Chinese (Simplified)', value: 'zh-hans' },
      { label: 'Italian',              value: 'it' },
      { label: 'Spanish',              value: 'es' },
      { label: 'French',               value: 'fr' },
      { label: 'German',               value: 'de' },
      { label: 'Russian',              value: 'ru' }
    ]"
    v-model="lang"
  />
   <img :src="pic">

  <hr>
  <h3>Dynamic Checkboxes</h3>
  <div class="row">
    <div class="col-sm-3"  v-for="box in boxes" :key="box.id" >
            <q-checkbox v-model="box.active"   :label="box.label" />
    </div>
  </div>
  <q-btn
      color="primary"
      label="Add Box"
      @click="addBox()"      
    />
  <hr>
  <q-tree
    :nodes="simple"
    node-key="label"
  />
  <hr>
  <h4>Timer</h4>
  <q-datetime v-model="startTime" type="datetime" float-label="Start Zeit" format="D.MMM.YYYY HH:mm" />
  <a class="u-link-white" href="#" @click="toggleTimer">
    {{ timeElapsed }}
   </a>

   <hr>
   <h4>Show Pic</h4>
   <q-btn
      color="primary"
      label="Get Original Pic"
      @click="getPic()"      
    />
     <img :src="newPic">
<p></p>
     <q-btn
      color="primary"
      label="Get Small Pic"
      @click="getSmallPic()"      
    />
     <img :src="smallPic">
  
  </q-page>
</template>


<script>
//require("quasar-framework/package.json"); // quasar-framework is a peer dependency. 
//var quasarCalendar = require("quasar-calendar")
import {eventBus} from '../main'
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'PageHome',
  data () {
    return {
      lang: this.$q.i18n.lang,
      pic: null,
      newPic: null,
      smallPic: null,
      form: {
        SessionId: null,
      },
      boxes:[
        {id: 1, label: 'one', active: false},
        {id: 2,label: 'two', active: false},
        {id: 3,label: 'and so on', active: false},
      ],
      simple: [
      {
        label: 'Satisfied customers',
        children: [
          {
            label: 'Good food',
            children: [
              { label: 'Quality ingredients' },
              { label: 'Good recipe' }
            ]
          },
          {
            label: 'Good service (disabled node)',
            disabled: true,
            children: [
              { label: 'Prompt attention' },
              { label: 'Professional waiter' }
            ]
          },
          {
            label: 'Pleasant surroundings',
            children: [
              { label: 'Happy atmosphere' },
              { label: 'Good table presentation' },
              { label: 'Pleasing decor' }
            ]
          }
        ]
      }
    ],
    timeElapsed: 'start',
    isRunning: false,
    interval: null, 
    startTime: new Date()
    }
  },
  methods: {
    changeLocal () {
      if (this.$i18n.locale === 'de') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'de'
      }
    },
    loadDialog (dialog){
      eventBus.$emit('loadDialog', dialog)
    },
    closeDialog (){
      eventBus.$emit('closeDialog', null)
    },
    addBox(){
      this.boxes.push({id: 4,label: 'new Box', active: false},)
    },
    toggleTimer() {
     
      if (this.isRunning) {
        clearInterval(this.interval);
        console.log('timer stops');
      } else {
        this.interval = setInterval(this.incrementTime, 1000);
      }
      this.isRunning = !this.isRunning
    },
    incrementTime() {
      
      //this.seconds = parseInt(this.seconds) + 1;
      var seconds = date.getDateDiff(new Date(), this.startTime, 'seconds')
      var tdate = new Date(null);
      tdate.setSeconds(seconds); // specify value for SECONDS here
      this.timeElapsed = tdate.toISOString().substr(11, 8);
      
    },
    getPic(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetPic"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.newPic = 'data:image/png;base64,' + response.data.Picture
              this.newPic = 'data:image/png;base64,' + response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    getSmallPic(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetSmallPic"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.newPic = 'data:image/png;base64,' + response.data.Picture
              this.smallPic = 'data:image/png;base64,' + response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }
  },
  watch: {
    lang (lang) {
      import(`quasar-framework/i18n/${lang}`).then(lang => {
        this.$q.i18n.set(lang.default)
      })
    }
  },
  created () {
    eventBus.$on('sendPic', (data) => {
      this.pic = data
    })
  }  
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
